import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable,Operator } from 'rxjs';
import { AuthService } from './shared/providers/auth.service';
import { constVariables } from './constants/ConstantPath';
import { tap } from "rxjs/operators";
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService  implements HttpInterceptor{

  constructor(private authService: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let tokenData = localStorage.getItem('AuthToken')!== null && localStorage.getItem('AuthToken')!== '' && localStorage.getItem('AuthToken')!== undefined ? localStorage.getItem('AuthToken') : '';
      let token = tokenData;
      
      const headers = new HttpHeaders({
          'authorization': token,
          'current_version': constVariables.current_version,
          'Content-Type': 'application/json'        
      });

      const cloneReq = request.clone({headers});

      return next.handle(cloneReq).pipe(tap((event: HttpEvent<any>)=> {
            if (event instanceof HttpResponse) {
              if(event.status === 401) {
                this.authService.logout();
              }
            }
      }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                  this.authService.logout();
              }
            }
      }));
  }
}
